import { createFileRoute, redirect } from "@tanstack/react-router";

import { hasPermission } from "@/modules/auth/lib/permissions";
import { ComplaintsPage } from "@/modules/complaints/pages/Complaints.page";

export const Route = createFileRoute("/__authed/m/complaints/new")({
	beforeLoad({ context }) {
		const user = "user" in context ? context.user : undefined;

		if (!hasPermission(user, "create_complaint")) {
			throw redirect({ to: "/m/dashboard" });
		}
	},
	component: ComplaintsPage,
});
